<template>
    <span>
        <Calendar
            v-if="operator === 'SINCE'"
            :model-value="parseDate(value)"
            :selectionMode="'single'"
            dateFormat="ddMyy"
            showButtonBar
            @update:model-value="emitDates($event)"
        />
        <Calendar
            v-if="operator === 'BETWEEN'"
            :model-value="dateArray(value)"
            :selectionMode="'range'"
            dateFormat="ddMyy"
            showButtonBar
            @update:model-value="emitDates($event)"
        />
    </span>
</template>

<script>
export default {
    name: 'DateRule',
    props: ['operator', 'value'],
    emits: ['handleValueChange'],
    methods: {
        parseDate(value) {
            let date = null;
            if (value && value.seconds !== undefined) {
                date = new Date(value.seconds * 1000);
            } else if (value) {
                date = new Date(value);
            }
            return date;
        },
        dateArray(value) {
            return Array.isArray(value) ? value.map((x) => this.parseDate(x)) : null;
        },
        emitDates(dates) {
            if (Array.isArray(dates)) {
                this.$emit(
                    'handleValueChange',
                    this.dateArray(dates).map((x) => (x ? x.toISOString() : null))
                );
            } else if (dates) {
                this.$emit('handleValueChange', this.parseDate(dates).toISOString());
            }
        },
    },
    mounted() {
        if (this.operator === 'BETWEEN' && !this.dateArray(this.value)) {
            this.$emit('handleValueChange', null);
        } else if (this.operator === 'SINCE' && Array.isArray(this.value)) {
            this.$emit('handleValueChange', null);
        }
        this.emitDates(this.value);
    },
};
</script>

<style scoped></style>
